import type { DevicePairStartRequest } from '@am3nd-org/pointcraft-types';

import { CONFIG } from 'src/environments/environment';
import type { ConfigType } from 'src/environments/type';

export const DEMO_ACCESS_PAIRING_CODE = '123456' as const;
export const DEMO_ACCESS_ACCOUNT_TYPE = 'DEMO' as const;

export type NonProductionAccountType = 'DEMO' | 'WEB_SALES';

type StandardPairingFields = {
  pairingCode?: string;
  requestedAccountType?: never;
};

type NonProductionAccessFields = {
  pairingCode: typeof DEMO_ACCESS_PAIRING_CODE;
  requestedAccountType: NonProductionAccountType;
};

export type DevicePairStartInput = DevicePairStartRequest &
  (StandardPairingFields | NonProductionAccessFields);

export const DEMO_ACCESS_PAIRING_FIELDS = {
  pairingCode: DEMO_ACCESS_PAIRING_CODE,
  requestedAccountType: DEMO_ACCESS_ACCOUNT_TYPE,
} as const;

type DemoAccessEnvironmentConfig = Pick<ConfigType, 'environment' | 'VITE_CURRENT_ENV'>;

/**
 * Keep the client gate fail-closed and independent from NODE_ENV. The backend
 * performs its own authoritative environment check before resolving a business.
 */
export function isDemoAccessEnvironment(config: DemoAccessEnvironmentConfig): boolean {
  const environment = config.environment.trim().toLowerCase();
  const { isLocal, isDev, isStaging, isMock, isProd } = config.VITE_CURRENT_ENV;

  if (isProd || !['local', 'dev', 'staging', 'mock'].includes(environment)) return false;

  return isLocal || isDev || isStaging || isMock;
}

export const canRequestDemoAccess = isDemoAccessEnvironment(CONFIG);
